// extracted by mini-css-extract-plugin
export var formContainer = "_kx-0";
export var message = "_kx-1";